export default __webpack_public_path__ + "static/media/header.731c7d53.png";